<div class="container-back">
  <button class="button" (click)="onClickBack()">
    <img [src]="getIcon" alt="" />
  </button>
</div>
